<template>
    <div class="electrictiy-bill-calculator__result-chart-container ">
        <canvas :id="chartCanvasId"></canvas>
        <div class="legend-container" id="year-chart-legend-container"></div>
    </div>
</template>

<script setup>
    import util from '../util'
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    
    const store = useWizardStore()
    const { appSettings, calculatedPrice } = storeToRefs(store);
   
    const props = defineProps({
        colors: { type: Object, required: true },
    });
    const chartCanvasId = "resultYearChart";

    let yearChart;

    const destroyChart = () => {
        if(yearChart) {
            yearChart.destroy();
        }
    }    

    const updateChart = () => {
        if(!yearChart) {
            initYearChart();
            return;
        }        
        yearChart.data.datasets.forEach((dataset) => {
            dataset.data = [
                calculatedPrice.value.total.EffectCost, 
                calculatedPrice.value.total.TransferCost, 
                calculatedPrice.value.total.EnergyTaxCost,
                calculatedPrice.value.total.FixedCharge, 
            ]
        });
        yearChart.update();
    }
    
    //Draw doughnut chart with summarized yearly data
    const initYearChart = () =>{        
        if(calculatedPrice.value.total == null) {
            return;
        }
        destroyChart();

        const yearChartColors = [
            props.colors.EffectCost.backgroundColor,
            props.colors.TransferCost.backgroundColor,
            props.colors.EnergyTaxCost.backgroundColor,
            props.colors.FixedCharge.backgroundColor,
        ];
        const yearChartLabelColors = [
            props.colors.EffectCost.textColor,
            props.colors.TransferCost.textColor,
            props.colors.EnergyTaxCost.textColor,
            props.colors.FixedCharge.textColor,
        ];
        const yearChartLabels = [
            appSettings.value.EffectCostText, 
            appSettings.value.TransferCostText, 
            appSettings.value.EnergyTaxCostText,
            appSettings.value.FixedChargeText, 
        ];        
        const yearChartData = [
            calculatedPrice.value.total.EffectCost, 
            calculatedPrice.value.total.TransferCost, 
            calculatedPrice.value.total.EnergyTaxCost,
            calculatedPrice.value.total.FixedCharge, 
        ];        

        const ctx = document.getElementById(chartCanvasId);
        yearChart = new window.Chart(ctx,
            {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            data: yearChartData,
                            backgroundColor: yearChartColors,
                            //label: 'Dataset 1',
                            borderWidth: 0
                        }
                    ],
                    labels: yearChartLabels
                },
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        }, 
                        tooltip: {
                            backgroundColor: '#C4E3DD',
                            borderColor: '#195D64',
                            cornerRadius: 9,
                            borderWidth: 1,
                            bodyColor: '#000',
                            bodySpacing: 3,
                            bodyFont: {
                                size: 14,
                            },
                            boxPadding: 4,
                            boxWidth: 14,
                            boxHeight: 14,
                            caretSize: 0,
                            callbacks: {
                                label: function(context) {                                    
                                    let label = context.dataset.label || '';
                                    return context.label +': ' + util.getFormatedPrice(context.parsed, 0);                                    
                                }
                            }
                        },                          
                        datalabels: {
                            formatter: function(value, context) {
                                return util.getFormatedPrice(value, 0);
                            },
                            color: yearChartLabelColors,
                            labels: {
                                title: {
                                    font: {
                                        weight: 'normal',
                                        size: 18,
                                    }
                                }
                            },
                            align: 'center',
                            textAlign: 'center',
                            display: function(context) {
                                const effectCostIndex = yearChartLabels.indexOf(appSettings.value.EffectCostText);
                                if(context.dataIndex === effectCostIndex) {
                                    return store.showEffectCostInResult ? 'auto' : false;
                                }                               
                                return 'auto';
                            }
                        },

                    },
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true
                    }

                },            
                plugins: [
                    ChartDataLabels,                     
                ]

            });
    }
    
    defineExpose({
        initYearChart,
        destroyChart,
        updateChart
    })

</script>



<style scoped>

</style>
